<template>
    <div>
        <register-summary :register-id="registerId" :show-register-data="showRegisterDate"/>
        <template v-if="showFrontBackPage">
            <div class="rounded-md bg-blue-50 p-4 mb-4 shadow">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <!-- Heroicon name: solid/information-circle -->
                        <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                             aria-hidden="true">
                            <path fill-rule="evenodd"
                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                  clip-rule="evenodd"/>
                        </svg>
                    </div>
                    <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-sm text-blue-700">Please report any damaged asbestos materials to a staff member at once</p>
                    </div>
                </div>
            </div>
        </template>
        <search-container @input="handleSearchInput" :floors="floors" :buildings="buildings" />
        <acms @image-click="openImageModal" :acms="acms"/>
        <no-access-areas @image-click="openImageModal" :no-access-areas="naas"></no-access-areas>
        <floorplans @image-click="openImageModal" :floorplans="floorplans"></floorplans>

        <div class="rounded-md bg-red-50 p-4 mb-4 shadow">
            <div class="flex">
                <div class="flex-shrink-0">
                    <!-- Heroicon name: solid/x-circle -->
                    <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                              clip-rule="evenodd"/>
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-red-800">This asbestos register provides information for the normal occupancy of the building
                        and general maintenance only. Intrusive works may require a more detailed inspection to be undertaken.</h3>
                </div>
            </div>
        </div>

        <template v-if="showFrontBackPage">
            <div class="bg-white shadow overflow-hidden sm:rounded-lg mb-4">

                <div class="grid grid-cols-2 gap-5">

                    <div class="col-span-2 border-t border-gray-200">
                        <dl>
                            <div class="border-b px-4 py-3 grid grid-cols-3">
                                <div class="col-span-3">
                                    <dt class="text-md font-medium text-gray-800 mb-2">
                                        ASBESTOS
                                    </dt>
                                    <dd class="mt-1 text-sm text-gray-600 sm:mt-0 sm:col-span-2">

                                        <p>
                                            Asbestos fibres are dangerous, breathing in air containing asbestos fibres can lead to asbestos-related diseases. In
                                            the UK around 5000 people die each year as a result of asbestos related diseases. Working on or damaging asbestos
                                            containing materials can release fibres into the air putting all people in this building at risk of developing
                                            asbestos related diseases.
                                        </p>

                                    </dd>
                                </div>
                            </div>
                        </dl>
                    </div>

                </div>
            </div>

            <div class="bg-white shadow overflow-hidden sm:rounded-lg mb-4">

                <div class="grid grid-cols-2 gap-5">

                    <div class="col-span-2 border-t border-gray-200">
                        <dl>
                            <div class="border-b px-4 py-3 grid grid-cols-3">
                                <div class="col-span-3">
                                    <dt class="text-md font-medium text-gray-800 mb-2">
                                        USING THIS REGISTER
                                    </dt>
                                    <dd class="mt-1 text-sm text-gray-600 sm:mt-0 sm:col-span-2 space-y-4">
                                        <p>
                                            This Asbestos Register contains information regarding previously identified Asbestos Containing Materials.
                                            Other Asbestos Containing Materials may be present within the property in areas not previously surveyed or within the
                                            building fabric.
                                        </p>
                                        <p>
                                            Information contained in this Asbestos Register has been extracted by UKNAR CIC (without any modification to such
                                            information) from the asbestos records named on the front page of this Asbestos Register.
                                            The Asbestos Records have been prepared by a third party (&lsquo;Asbestos Specialist&rsquo;) under appointment of the
                                            person responsible for health and safety matters at this property (&lsquo;Client&rsquo;).
                                            UKNAR CIC accepts no liability for the accuracy or adequacy of this information or any recommendations given.
                                        </p>
                                        <p>
                                            The Asbestos Records or its accuracy or adequacy is the responsibility of the Client.
                                            UKNAR CIC provides no advice on the type or scope or content of the Asbestos Records nor on which records and at which
                                            frequency such records must be uploaded onto UKNAR for awareness and access by persons visiting the property;
                                            this remains the decision of the Client. UKNAR CIC does not warrant that the Asbestos Records have been produced or
                                            prepared by a competent person. UKNAR CIC does not prepare or write any parts of the Asbestos Records.
                                        </p>
                                        <p>
                                            If in doubt, please contact the building manager to obtain the original records.
                                        </p>
                                        <p>
                                            Use this document to identify asbestos containing materials prior to commencing works. If your works could disturb any
                                            asbestos containing materials
                                            control measures must be put in place to ensure your safety and the safety of other people present within the
                                            building.
                                        </p>
                                        <p>
                                            Works on asbestos containing materials must only be undertaken by individuals who have received appropriate training
                                            and have the necessary equipment to
                                            carry out such works safely and in accordance with the Control of Asbestos Regulations 2012. Works on many materials
                                            may only be undertaken by
                                            Licenced Asbestos Removal Contractors.
                                        </p>
                                        <p>
                                            Please report any damaged asbestos containing materials using the emergency contact number.
                                        </p>
                                        <p>
                                            For more information regarding asbestos, the regulations and your responsibilities when working with or in the
                                            vicinity of asbestos materials please visit the Health &amp;
                                            Safety Executive web site:
                                            <a href="http://www.hse.gov.uk/asbestos/index.htm" target="_blank">http://www.hse.gov.uk/asbestos/index.htm</a>
                                        </p>
                                    </dd>
                                </div>
                            </div>
                        </dl>
                    </div>

                </div>
            </div>

            <div class="rounded-md bg-red-50 p-4 shadow">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <!-- Heroicon name: solid/x-circle -->
                        <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                  clip-rule="evenodd"/>
                        </svg>
                    </div>
                    <div class="ml-3">
                        <h3 class="text-sm font-medium text-red-800">Failure to comply with the Control of Asbestos Regulations 2012 is a criminal
                            offence which may result in fines and / or imprisonment.</h3>
                    </div>
                </div>
            </div>

            <div class="p-2 text-center mt-10 text-sm">
                <div class="font-bold">UK National Asbestos Register (UKNAR) CIC.</div>
                <div class="font-bold">A Community Interest Company Registered in England and Wales No. 12433778</div>
                <div>
                    Tel: <a href="tel:+442036334303">020 3633 4303</a>
                    Email: <a href="mailto:enquiries@uknar.org">enquiries@uknar.org</a>
                    Web: <a href="https://www.uknar.org">www.uknar.org</a>
                </div>
            </div>
        </template>

        <image-modal @closed="closeImageModal()" :open="imageModal.isOpen" :image-url="imageModal.imageUrl"/>
    </div>
</template>

<script>
import RegisterSummary from "./RegisterSummary";
import Acms from "./Acms";
import NoAccessAreas from "./NoAccessAreas";
import Floorplans from "./Floorplans";
import ImageModal from "../../components/ImageModal";
import SearchContainer from "./SearchContainer";

export default {
    name: 'QrRegisterView',
    components: {SearchContainer, ImageModal, Floorplans, NoAccessAreas, Acms, RegisterSummary},
    props: {
        registerId: {
            type: Number,
            required: true
        },
        showFrontBackPage: {
            default: true
        },
        showRegisterDate: {
            default: false
        }
    },

    computed: {
        floors() {
            const floors = this.filteredData.map((o) => o.floor);
            return [...new Set(floors)];
        },

        buildings() {
            return this.filteredData.map(o => o.buildings).reduce((a, b) => {
                return a.concat(b)
            }, []).filter((o, index, self) => self.indexOf(o) === index);
        },

        acms() {
            let acms = this.filteredData.map(o => o.acms).reduce((a, b) => {
                return a.concat(b)
            }, []);

            if (this.selectedBuildings.length) {
                acms = acms.filter(o => this.selectedBuildings.indexOf(o.building) > -1)
            }

            return acms
        },

        naas() {
            let naas = this.filteredData.map(o => o.no_access_areas).reduce((a, b) => {
                return a.concat(b)
            }, []);

            if (this.selectedBuildings.length) {
                naas = naas.filter(o => this.selectedBuildings.indexOf(o.building) > -1)
            }

            return naas;
        },

        floorplans() {
            let floorplans = this.filteredData.map(o => o.floorplans).reduce((a, b) => {
                return a.concat(b)
            }, [])

            if (this.selectedBuildings.length) {
              floorplans = floorplans.filter(o => this.selectedBuildings.indexOf(o.building_name) > -1)
            }

            return floorplans
        }
    },

    data() {
        return {
            filteredData: [],
            floorsData: [],
            loading: false,
            imageModal: {
                isOpen: false,
                imageUrl: null
            },
            elAcm: null,
            elNaa: null,
            elFloorplan: null,
            offsets: {
                acm: null,
                naa: null,
                floorplan: null,
            },
            selectedBuildings: []
        }
    },

    mounted() {
        this.loadFloorsData();
    },

    methods: {
        handleScrollEvent() {
            window.makeElementSticky(this.elAcm, this.offsets.acm,
                () => {
                    document.getElementById('acmsContainer').classList.add('on-screen');
                }, () => {
                    document.getElementById('acmsContainer').classList.remove('on-screen');
                });
            window.makeElementSticky(this.elNaa, this.offsets.naa,
                () => {
                    document.getElementById('naasContainer').classList.add('on-screen');
                }, () => {
                    document.getElementById('naasContainer').classList.remove('on-screen');
                });
            window.makeElementSticky(this.elFloorplan, this.offsets.floorplan,
                () => {
                    document.getElementById('floorplansContainer').classList.add('on-screen');
                }, () => {
                    document.getElementById('floorplansContainer').classList.remove('on-screen');
                });
        },

        handleSearchInput({ buildings, floors }) {
            this.selectedBuildings = buildings;

            this.filteredData = this.floorsData;

            if (buildings.length > 0) {
                for (const building of buildings) {
                    this.filteredData = this.filteredData.filter(o => o.buildings.indexOf(building) > -1);
                }
            }

            this.filteredData = floors.length > 0
                ? this.filteredData.filter(o => floors.indexOf(o.floor) > -1)
                : this.filteredData;

            window.removeEventListener('scroll', this.handleScrollEvent);
            this.elAcm.classList.remove('el-sticky', 'sm-el-sticky');
            this.elNaa.classList.remove('el-sticky', 'sm-el-sticky');
            this.elFloorplan.classList.remove('el-sticky', 'sm-el-sticky');
            setTimeout(() => {
                this.offsets = {
                    acm: this.elAcm.offsetTop,
                    naa: this.elNaa.offsetTop,
                    floorplan: this.elFloorplan.offsetTop,
                }

                window.addEventListener('scroll', this.handleScrollEvent);
            }, 1000);
        },

        openImageModal(imageUrl) {
            this.imageModal = {
                isOpen: true,
                imageUrl: imageUrl
            }
        },

        closeImageModal() {
            this.imageModal = {
                isOpen: false,
                imageUrl: null
            }
        },

        loadFloorsData() {
            this.loading = true;
            axios.get(route('ajax.registers.floors', this.registerId))
                .then(response => {
                    this.floorsData = response.data.data;
                    this.filteredData = response.data.data;

                    setTimeout(() => {
                        this.elAcm = document.getElementById('acmsHeader');
                        this.elNaa = document.getElementById('naasHeader');
                        this.elFloorplan = document.getElementById('floorplansHeader');

                        this.offsets = {
                            acm: this.elAcm.offsetTop,
                            naa: this.elNaa.offsetTop,
                            floorplan: this.elFloorplan.offsetTop,
                        }

                        window.addEventListener('scroll', this.handleScrollEvent);
                    }, 1000);
                })
                .finally(() => {
                    this.loading = false;
                })
        }
    }
}
</script>
